const ExtraUnauthorizedModal = () => null;

export default ExtraUnauthorizedModal;
